import { SimpleChanges } from '@angular/core';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ChartDataSets } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { ApiService } from 'src/app/core/api.service';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit, OnChanges {
  @Input() lesson: number;
  @Input() type: string;
  @Input() lessonType: string;

  chartPieData: number[] = [];
  chartLineData: ChartDataSets[] = [
    { data: [], label: '' },
  ];
  chartLabels: Label[] = []; 
  
  chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      position: 'bottom',
    },
  };

  chartColors: Color[] = [
    {backgroundColor: ['rgba(132,199,172,1)', 'rgba(248,175,38,1)']}
  ];
  chartLegend = true;

  constructor(
    private authService: AuthService,
    private apiService: ApiService) { }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['lesson']) {
      this.refresh();
    } 
  }

  ngOnInit() {

  }

  private refresh() {
    this.loadChartResult();
  }

  // load results
  private loadChartResult() {
    const {userid, language_in_use} = this.authService.user$.value;

    let request: Observable<any>;
    if(this.lessonType === 'basic'){
      if(this.type === 'pie') { request = this.apiService.loadChartPie(userid, this.lesson, language_in_use) }
      if(this.type === 'line') { request = this.apiService.loadChartLine(userid, this.lesson, language_in_use) }
    }

    if(this.lessonType === 'advanced'){
      if(this.type === 'pie') { request = this.apiService.loadAdvancedChartPie(userid, this.lesson, language_in_use) }
      if(this.type === 'line') { request = this.apiService.loadAdvancedChartLine(userid, this.lesson, language_in_use) }
    }


    // request chart data
    request 
      .subscribe(value => {
        // setup chart
        if(this.type === 'pie') { this.setupPieChart(value) };
        if(this.type === 'line') { this.setupLineChart(value) };
      })
  }

  private setupPieChart(result) {
    const resultData = result.result.z;
    
    const {language_in_use} = this.authService.user$.value;

    // labels translations
    switch (language_in_use) {
      case 'uk':
        this.chartLabels = this.lessonType === 'basic' 
          ? ['Total Keystrokes', 'Total Errors']
          : ['WPM', 'Accuracy(%)']
        break;

      case 'dk':
        this.chartLabels = this.lessonType === 'basic' 
          ? ['Samlede tastetryk', 'Samlede Fejl']
          : ['APM', 'Fejlanslag(%)']
        break;

      case 'de':
        this.chartLabels = this.lessonType === 'basic' 
          ? ['Total Keystrokes', 'Total Errors']
          : ['WPM', 'Accuracy(%)']
        break;
    }
   
    this.chartPieData = resultData.map(value => value.country);
  }

  private setupLineChart(result) {
    const resultData = result.result.z;
    this.chartLabels = resultData.map(value => value.index);

    // strokes
    let strokes:number[] = [];
    resultData.forEach(value => {
      strokes.push(value.strokes);
    })    

    // errors
    let errors:number[] = [];
    resultData.forEach(value => {
      errors.push(value.errors);
    })

    const {language_in_use} = this.authService.user$.value;

    // lang setup
    switch (language_in_use) {
      case 'uk':
        this.chartLineData = [
          { data: strokes, label: 'Keystrokes', fill: false, borderColor: 'rgba(132,199,172,1)'},
          { data: errors, label: 'Errors', fill: false, borderColor: 'rgba(248,175,38,1)' }
        ];
        break;

      case 'dk':
        this.chartLineData = [
          { data: strokes, label: 'Anslag', fill: false, borderColor: 'rgba(132,199,172,1)'},
          { data: errors, label: 'Fejlsanslag', fill: false, borderColor: 'rgba(248,175,38,1)' }
        ];
        break;

      case 'de':
        this.chartLineData = [
          { data: strokes, label: 'Keystrokes', fill: false, borderColor: 'rgba(132,199,172,1)'},
          { data: errors, label: 'Errors', fill: false, borderColor: 'rgba(248,175,38,1)' }
        ];
        break;
    
      default:
        break;
    }         
  }

}
